import React from "react";
import images from "../../assets/images/images";
import CustomDialog from "../../customComponents/customDialog/CustomDialog";
import i18n from "../../i18n/i18n";
import { saveAs } from "file-saver";
import {
  getDocumentTypeSvgIcon,
  getServerImageUrl,
} from "../../constants/constants";
import { getDocFieldTranslationKey, getDocFieldTranslationKeyforDoc } from "../../helpers/CommonHelpers";

const ViewDocument = ({
  onEditPress = () => { },
  onDeletePress = () => { },
  onSharePress = () => { },
  onClosePress = () => { },
  onImagePress = () => { },
  imageData,
  docInfo,
  fieldList
}) => {



  const handleClick = async () => {
    window.open(imageData?.url, "_blank");
    let url = imageData?.url;
    if (imageData?.file_type == "pdf") {
      let fileType = `${docInfo?.name}.pdf`;
      fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, fileType);
        })
        .catch((error) => {
          console.error("Error downloading file:", error);
        });
    } else {
      fetch(url, {
        headers: {
          Accept: "*/*",
          "Accept-Encoding": "gzip, deflate, br",
          "Content-Type": "image/jpeg",
          // mode: "cors",
          credentials: "include",
        },
      })
        .then((response) => response.blob())
        .then((blob) => {
          saveAs(blob, `${docInfo?.name}.jpg`);
        })
        .catch((error) => {
          console.error("Error downloading image:", error);
        });
    }
  };
  const Meta_Lang = getDocFieldTranslationKeyforDoc()
  return (
    <div className="right-adm-content-bx mt-4 p-2">
      <div className="d-flex justify-content-center mt-2">
        <div
          style={{ cursor: "pointer" }}
          onClick={onEditPress}
          className="ad_bt_end me-2"
        >
          <i className="fa fa-pencil" aria-hidden="true" />
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={() => {
            CustomDialog.confirm(
              i18n.t("do_you_want_to_delete_this_text"),
              onDeletePress
            );
          }}
          className="ad_bt_end me-2"
        >
          <i className="bi bi-trash" />
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={onSharePress}
          className="ad_bt_end me-2"
        >
          <i className="bi bi-share" />
        </div>
        <div
          style={{ cursor: "pointer" }}
          onClick={onClosePress}
          className="close_icon me-2"
        >
          <button
            onClick={onClosePress}
            aria-label="Close"
            className="close-button me-2"
            style={{
              background: "none",
              border: "none",
              cursor: "pointer",
              fontSize: "1.25rem",
              color: "#333",
            }}
          >
            &times;
          </button>

        </div>
      </div>
      {/* <span className="alert_badge_cld">
        <i className="bi bi-exclamation-octagon fs-5 me-2" />
        Document is Expired */}
      {/* {isExpiredInDays < 0
          ? "Document is expired"
          : isExpiredInDays == 0
          ? "Document will expire today"
          : `Document will expire in ${isExpiredInDays} day${
              isExpiredInDays <= 1 ? "" : "s"
            }`} */}
      {/* </span> */}
      <div className="doc-pasport-upload mt-4">


        <p>{docInfo?.name}</p>
        <div
          style={{
            marginTop: 10,
            borderRadius: 10,
            overflow: "hidden",
            cursor: "pointer",
            marginBottom: 10,
          }}
          className="document-file-bx overlay_cls position-relative"
          onClick={handleClick}
        >
          {imageData?.url && (
            <>
              <i onClick={(e) => {
                // e.stopPropagation(); // prevent event bubbling
                handleClick();       // call your existing download logic
              }} style={{ position: 'absolute', left: '45%', top: '45%', fontSize: 25 }} className="text-center bi bi-download" />
              <img
                style={{ height: "100%", width: "100%", objectFit: "cover" }}
                src={
                  imageData?.url?.includes("pdf")
                    ? images.pdfImage
                    : imageData?.url
                }
                alt=""
              />
            </>
          )}
        </div>
        {/* <div
          style={{
            marginTop: 10,
            borderRadius: 10,
            overflow: "hidden",
            cursor: "pointer",
          }}
          className="document-file-bx overlay_cls position-relative"
          onClick={() => {
            window.open(imageData?.url2);
          }}
        >
          {imageData?.url2 && (
            <img
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
              }}
              src={
                imageData?.url2?.includes("pdf")
                  ? images.pdfImage
                  : imageData?.url2
              }
              alt=""
            />
          )}
        </div> */}
        {/* <div
          style={{
            marginTop: 10,
            borderRadius: 10,
            overflow: "hidden",
            cursor: "pointer",
          }}
          className="document-file-bx overlay_cls position-relative"
          onClick={() => {
            window.open(imageData?.url3);
          }}
        >
          {imageData?.url3 && (
            <img
              style={{
                height: "100%",
                width: "100%",
                objectFit: "cover",
                cursor: "pointer",
              }}
              src={
                imageData?.url3?.includes("pdf")
                  ? images.pdfImage
                  : imageData?.url3
              }
              alt=""
            />
          )}
        </div> */}
        {/* <div
          style={{
            marginTop: 10,
            borderRadius: 10,
            overflow: "hidden",
            cursor: "pointer",
          }}
          className="document-file-bx overlay_cls position-relative"
          onClick={() => {
            window.open(imageData?.url4);
          }}
        >
          {imageData?.url4 && (
            <img
              style={{ height: "100%", width: "100%", objectFit: "cover" }}
              src={
                imageData?.url4?.includes("pdf")
                  ? images.pdfImage
                  : imageData?.url4
              }
              alt=""
            />
          )}
        </div> */}
        {/* <span className="view-img-ops">
              <Link to="javascript:;" className="img-preview text-white">
                <i className="bi bi-eye" />
                <p className="text-white m-0">Preview</p>
              </Link>
            </span> */}
      </div>
      <div className="documents_details_card">
        <div className="user-ifo-card d-flex align-items-center mb-3">
          {/* {imageData?.url && (
            <img
              src={
                imageData?.url?.includes("pdf")
                  ? images.pdfImage
                  : imageData?.url
              }
              alt=""
            />
          )} */}
          <img
            src={getDocumentTypeSvgIcon(docInfo?.doc_type_id)}
            style={{
              // backgroundColor: "#ff685a",
            }}
            alt=""
            height={25}
            width={25}
          />
          <p className="m-0">{docInfo?.name}</p>
        </div>
        {docInfo?.document_info?.map((item) => {


          return (
            <>
              {item.meta_key != "QR" ? (
                <p className="listdetails-doc ">
                  <span>{(() => {
                    const matchedItem = fieldList.find(
                      item2 => item2.meta_key === item?.meta_key
                    );
                    return matchedItem?.[Meta_Lang];
                  })()}</span>{" "}
                  <strong>{item?.meta_value}</strong>
                </p>
              ) : (
                <p className="listdetails-doc ">
                  <span>{item?.meta_key}</span>{" "}
                  <img
                    src={getServerImageUrl(docInfo?.qr_code)}
                    alt=""
                    width={50}
                    height={50}
                  />
                </p>
              )}
            </>
          );
        })}
      </div>
    </div>
  );
};

export default ViewDocument;
